import {
    ProcessFieldBase,
    ProcessFieldRegistryTable,
    ServiceVM,
} from '@shared/types/process';
import { TableField } from '@features/TableField/TableField';

interface Props {
    field: ProcessFieldBase & ProcessFieldRegistryTable;
    service?: ServiceVM;
    disabled?: boolean;
    readOnly?: boolean;
    name?: string;
}

export function ProcessFieldRegistryTableField({
    field,
    service,
    ...props
}: Props) {
    return <TableField field={field} service={service} {...props} />;
}
